import { ArrowRight, MapPin, ShieldCheck } from "lucide-react";
import { SERVICE_CHIPS, BRAND } from "@/lib/site-data";

export default function Hero() {
  return (
    <section id="top" className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden">
      {/* subtle decor */}
      <div aria-hidden className="absolute -top-20 -left-24 w-[520px] h-[520px] rounded-full bg-brand-clay/5 blur-3xl" />
      <div aria-hidden className="absolute top-40 right-0 w-[380px] h-[380px] rounded-full bg-brand-pine/5 blur-3xl" />

      <div className="container-site relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left */}
          <div className="lg:col-span-7 animate-fade-up" data-testid="hero-content">
            <div className="inline-flex items-center gap-2 bg-white border border-brand-line rounded-full px-4 py-2 mb-6 shadow-sm">
              <MapPin size={14} className="text-brand-clay" />
              <span className="text-xs font-medium text-brand-text">
                Serving every corner of Pune & PCMC City
              </span>
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[0.98] text-brand-pine">
              Professional Dental Care
              <span className="block italic font-light text-brand-clay">
                Delivered to Your Doorstep in Pune.
              </span>
            </h1>

            <p className="mt-6 text-lg text-brand-textMuted max-w-xl leading-relaxed">
              Skip the traffic and clinic waiting rooms. Our expert dentists
              bring high-tech, painless dental treatments — from check-ups and
              dentures to root canals — directly to your home across Pune & PCMC.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a href="#booking" data-testid="hero-book-btn" className="btn-primary">
                Book Your Home Visit Today <ArrowRight size={18} />
              </a>
              <a
                href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
                  "Hi! I'd like a free WhatsApp consultation for a home dental visit in Pune."
                )}`}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-whatsapp-btn"
                className="btn-outline"
              >
                WhatsApp for Free Consultation
              </a>
            </div>

            {/* Trust row */}
            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3">
              <div className="flex items-center gap-2 text-sm text-brand-text">
                <ShieldCheck size={18} className="text-brand-clay" strokeWidth={1.6} />
                Sterilised equipment, every visit
              </div>
            </div>

            {/* service chips */}
            <div className="mt-8" data-testid="service-chips">
              <p className="overline mb-3">Book care for</p>
              <div className="flex flex-wrap gap-2">
                {SERVICE_CHIPS.map((s) => (
                  <span key={s} className="chip">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-3xl overflow-hidden bg-brand-bg">
              <img
                src="/hero-home-visit.png"
                alt="Dentist treating an elderly patient at home with a portable mobile dental setup"
                className="w-full h-[460px] md:h-[600px] object-contain"
                loading="eager"
                decoding="async"
              />
            </div>
            {/* floating stat chip */}
            <div className="absolute -bottom-6 -left-6 md:-left-10 bg-white rounded-2xl border border-brand-line shadow-lg p-4 md:p-5 max-w-xs">
              <p className="text-xs text-brand-textMuted">
                successful home visits across Pune & beyond — gentle, precise, on time.
              </p>
            </div>
            <div className="hidden md:block absolute -top-5 right-6 bg-brand-pine text-white rounded-full px-5 py-2 text-sm shadow-lg">
              No clinic queues.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
